// extracted by mini-css-extract-plugin
module.exports = {"root":"dropdown-menu-separator_root__OLSWQ"};